import { Fragment } from 'react';
import { Box, Grid, Typography } from '@mui/material';

import { Ti18nId } from 'hooks/useI18n';
import { IFormRegister, IFormValues, IFormWatch } from 'routes/Main/type';

import SectionTitle from '../../components/SectionTitle';

interface Props extends IFormValues, IFormWatch, IFormRegister {
  disabled?: boolean;
  onRequired: (id: Ti18nId) => void;
  onSuccess: (message: string) => void;
}

const CVCthree = (props: Props) => {
  const { disabled, register } = props;

  const info = [
    '為減輕插管過程中的疼痛，會在插入部位施打局部麻醉。',
    '用注射器穿刺血管後，會插入導引器來建立導絲通道，以利導管置入。',
    '導管會透過導引器插入血管並固定在皮膚上。',
    '插管所需時間約為 20～40 分鐘，但可能依照操作情況有所不同。',
  ];

  return (
    <Fragment>
      <SectionTitle title="3. 中心靜脈導管插入方法." />
      <Box sx={{ margin: '38px 0px 30px 20px' }}>
        <Grid container xs={11.8}>
          {info.map(a => {
            return (
              <Grid item xs={11.5}>
                <Typography sx={{ fontSize: '14px', lineHeight: '30px' }}>
                  • {a}
                </Typography>
              </Grid>
            );
          })}
        </Grid>
      </Box>
    </Fragment>
  );
};

export default CVCthree;
